<div class="legal-lang-toggle" role="group" [attr.aria-label]="lang === 'fr' ? 'Choix de la langue' : 'Language selection'">
  <button type="button"
          [class.active]="lang === 'en'"
          [attr.aria-pressed]="lang === 'en'"
          (click)="select('en')">English</button>
  <span class="sep" aria-hidden="true">|</span>
  <button type="button"
          [class.active]="lang === 'fr'"
          [attr.aria-pressed]="lang === 'fr'"
          (click)="select('fr')">Français</button>
</div>
